import type { Answer } from "../../../../../../components/Questionnaire/Section/Question/types";
import type { VisibilityMap } from "../../../../../../components/Questionnaire/validation/form/types";
import type { Groups, Answers } from "../../../../types";
import { isShadowGroup } from "../../../../types";
import { deriveShadowChildrenAnswers } from "../shared/deriveShadowChildrenAnswers";

type DeriveNoGroupUpdatesArgs = {
  groupNames: string[];
  groups: Groups;
  answers: Answers;
  visibility: VisibilityMap;
  defaultNoAnswers?: Record<string, Answer>;
};

/**
 * Pure helper: derive answers and visibility when a normal group is set to "no"
 */
export const deriveNoGroupUpdates = ({
  groupNames,
  groups,
  answers,
  visibility,
  defaultNoAnswers,
}: DeriveNoGroupUpdatesArgs): {
  answers: Answers;
  visibility: VisibilityMap;
} => {
  let nextAnswers = { ...answers };
  const nextVisibility = { ...visibility };

  for (const child of groupNames) {
    const childGroup = groups[child];
    if (isShadowGroup(childGroup)) {
      nextAnswers[child] = [];
      nextAnswers = deriveShadowChildrenAnswers({
        shadowGroup: childGroup,
        selectedValues: [],
        answers: nextAnswers,
      });
    } else {
      nextAnswers[child] = defaultNoAnswers?.[child] ?? "no";
    }
    nextVisibility[child] = false;
  }

  return { answers: nextAnswers, visibility: nextVisibility };
};
